<template>
  <transition
    name="transition-fade"
    mode="out-in"
  >
    <slot />
  </transition>
</template>

<style lang="scss">
  .transition-fade {
    &-enter-active,
    &-leave-active {
      transition:
        opacity 150ms,
    }
    &-enter,
    &-leave-to {
      opacity: 0,
    }
  }
</style>

<script>
// Export
export default {
  name: `transitions-fade`,

};
</script>



// WEBPACK FOOTER //
// Fade.vue?eba03546